import React from "react";
import { Button } from "antd";

import ClientTransferCalculator from "components/transfercalculator/ClientTransferCalculator_new";
import { getCurrentCustomer } from "api/api";
import { displayError, displayGenericError } from "common/notifications";

import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import withUseIntl from "components/withUseIntl";
import { connect, useSelector } from "react-redux";
import { setDoExportClick, setLoading } from "../../rx/orders/orderExportAction";
import { withRouter } from "react-router-dom";
import { displayNumberWithComma, formatMoney } from "../../utils/utils";

export class SetupPaymentTab extends React.Component {
  state = {
    payment: this.props.payment || null,
    accountStatus: null,
    currentCustomer: null,
    disableContinue: false,
    errorMsgOverLimit: '',
  };

  componentDidMount() {
    this.loadCurrentCustomer();
  }

  loadCurrentCustomer = () => {
    return getCurrentCustomer()
      .then(response => {
        this.setState({
          accountStatus: response.status,
          currentCustomer: response
        });
      })
      .catch(error => {
        displayGenericError(error);
      });
  };

  onPaymentChanged = newPayment => {
    if (newPayment.sourceValue.amount < 0) {
      newPayment.sourceValue.amount = 0;
    }

    if (newPayment.targetValue.amount < 0) {
      newPayment.targetValue.amount = 0;
    }
    this.setState({
      payment: newPayment,
    });
    this.props.checkValidPayment(newPayment);
  };
  toCheckValidPayment = () =>{
    this.props.toCheckValidPayment();
  }

  checkInvalidPaymentWithCustomerTierRange = () => {
    let payment = this.state.payment;
    let newTransferRoute = payment.transferRoute;
    if (payment) {
      if (newTransferRoute) {
        if (this.invalidLimitCustomerTierRange(newTransferRoute.customizedRate, payment.sourceValue.amount)) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  invalidLimitCustomerTierRange(customizedRate, amount) {
    if (customizedRate && customizedRate.length > 0) {
      let from = Math.min.apply(null, customizedRate.map(item => item.from));
      let to = Math.max.apply(null, customizedRate.map(item => item.to));
      let amountVal = Number(amount);
      if (amountVal < from || amountVal > to) {
        return true;
      }
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.payment && this.state.payment && !this.state.payment.dbsChargeBearer && this.state.payment.dbsChargeBearer != prevState.payment.dbsChargeBearer) {
      let payment = this.state.payment;
      payment.dbsChargeBearer = prevState.payment.dbsChargeBearer;
      this.setState({
        payment: payment
      })
    }
  }

  render() {
    return (
      <>
        {/* <h4 className={"bp-page-headline"}><FormattedMessage id="app.panel.sendpaymenttab.howmuchtosend"/></h4> */}

        <div className="bp-page-body setup-amount-tab">
          <ClientTransferCalculator
            onChange={this.onPaymentChanged}
            toCheckValidPayment = {this.toCheckValidPayment}
            transfer={this.state.payment}
            currentCustomer={this.state.currentCustomer}
            errorMsgOverLimit={this.state.errorMsgOverLimit}
            updatePaymentActiveTabFee={(activeTabFee) => {
              let payment = this.state.payment;
              if (payment) {
                payment.activeTabFee = activeTabFee;
                this.props.updatePayment(payment)
              }
            }
            }
            updateSwiftFee={(swiftFee, activeTabFee, dbsChargeBearer) => {
              let payment = this.state.payment;
              if (payment) {
                payment.swiftFee = swiftFee;
                payment.activeTabFee = activeTabFee;
                payment.dbsChargeBearer = dbsChargeBearer;
                this.props.updatePayment(payment)
                // this.setState({
                //   payment:payment
                // })
              }
            }}
          />
        </div>

        {(this.props.currentCustomer && !this.props.currentCustomer.readOnly) && <div className="bp-padded-top-panel">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Button
              htmlType={"button"}
              type="primary"
              size="large"
              disabled={this.props.disableContinue}
              className="btn-wide-lg"
              style={{ width: '400px' }}
              onClick={() => {
                const intl = this.props.useIntl;
                // const intl = useIntl();
                if (this.checkInvalidPaymentWithCustomerTierRange()) {
                  let payment = this.state.payment;
                  let transferRoute = payment.transferRoute;
                  if (transferRoute) {
                    let customizedRate = transferRoute.customizedRate;
                    let maxValue = Math.max.apply(null, customizedRate.map(item => item.to))

                    this.setState({
                      errorMsgOverLimit: intl.formatMessage({ id: "app.panel.clienttransfercalculator.customerTier.limit" })
                        + payment.targetValue.currency + " " + displayNumberWithComma(maxValue)
                    });

                    return;
                  }
                }
                let payment = this.state.payment;
                if (payment) {
                  // payment.dbsChargeBearer = this.state.dbsChargeBearer;
                  if (payment.activeTabFee === 'swift') {
                    if (payment.swiftFee == null) {
                      displayError(intl.formatMessage({ id: "app.panel.transferdetailspanel.swift.fee.required" }))
                      return;
                    } else {
                      payment.fee = payment.swiftFee;
                    }
                  }
                  this.props.onCompleted(payment)
                }
              }}
            >
              <FormattedMessage id="app.panel.sendpaymenttab.continue" />
            </Button>
          </div>
        </div>}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentCustomer,
    // success: state.exportOrderData.success
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setLoading: (val) => dispatch(setLoading(val)),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withUseIntl(SetupPaymentTab))
)
